import { initFooterSection } from "@/modules/section-footer";
import { categoriesMenu } from "@/modules/categories-menu";
import ready from "@/scripts/helpers/dom/ready";
import cookiePopup from "@/modules/popup-cookie";
import { headerFunctions } from "@/modules/section-header";



const breakpoint = '(min-width: 1145px)';

if (document.querySelector('.is-active')) {
  const activeTab = document.querySelector('.is-active');
  activeTab.addEventListener('click', e => {
    e.preventDefault();
  });
}

// if (document.querySelectorAll('.card')) {
//   const cards = document.querySelectorAll('.card');
//   cards.forEach(card => {
//     card.addEventListener('click', e => {
//       if (card.hasAttribute('href')) {
//         window.location.href = card.getAttribute('href');
//       }
//       else if (card.querySelector('.form-list__link')) {
//         window.location.href = card.querySelector('.form-list__link').getAttribute('href');
//       }
//     });
//   });
// }


function cardClickHandler() {
  const cards = document.querySelectorAll(".card");
  cards.forEach(card => {
    card.addEventListener("click", event => {
      event.preventDefault();
      if (event.target === card || card.contains(event.target)) {
        window.location.href = card.getAttribute("href");
      }
    });
    
    const buttons = card.querySelectorAll(".form-list__link");
    buttons.forEach(button => {
      button.addEventListener("click", event => {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = button.getAttribute("href");
      });
    });
  });
}







ready( () => {
  headerFunctions();
  initFooterSection();
  categoriesMenu(undefined);
  setTimeout(() => {
    cookiePopup();
  }, 4000);
});